<template>
  <!-- @touchstart="handleTouchstart" -->
  <!-- @mousedown="handleMousedown" -->
  <div
    ref="cont"
    class="resize-box rszbox"
    :style="boxStyle"
  >
    <div class="rszbox_content">
      <slot :dimensions="{ height: current.height, width: current.width }"></slot>
    </div>
    <div
      v-for="item in handles"
      :key="item"
      :class="`rszbox_${item}`"
      class="rszbox_edge"
      @mousedown="e => handleMousedown(e, { startEdge: item })"
      @touchstart="e => handleTouchstart(e, { startEdge: item })"
    ></div>
    <div
      v-for="item in cornerHandles"
      :key="item"
      :class="`rszbox_corner_${item}`"
      class="rszbox_corner"
      @mousedown="e => handleMousedown(e, { startCorner: item })"
      @touchstart="e => handleTouchstart(e, { startCorner: item })"
    ></div>
    <!-- <div
      @mousedown="(e) => handleMousedown(e, { startEdge: 'top' })"
      @touchstart="(e) => handleTouchstart(e, { startEdge: 'top' })"
      class="rszbox_edge rszbox_top"
    />
    <div
      @mousedown="(e) => handleMousedown(e, { startEdge: 'bottom' })"
      @touchstart="(e) => handleTouchstart(e, { startEdge: 'bottom' })"
      class="rszbox_edge rszbox_bottom"
    />
    <div
      @mousedown="(e) => handleMousedown(e, { startEdge: 'right' })"
      @touchstart="(e) => handleTouchstart(e, { startEdge: 'right' })"
      class="rszbox_edge rszbox_right"
    />
    <div
      @mousedown="(e) => handleMousedown(e, { startEdge: 'left' })"
      @touchstart="(e) => handleTouchstart(e, { startEdge: 'left' })"
      class="rszbox_edge rszbox_left"
    />
    <div
      @mousedown="(e) => handleMousedown(e, { startCorner: 'top_left' })"
      @touchstart="(e) => handleTouchstart(e, { startCorner: 'top_left' })"
      class="rszbox_corner rszbox_corner_top_left"
    />
    <div
      @mousedown="(e) => handleMousedown(e, { startCorner: 'top_right' })"
      @touchstart="(e) => handleTouchstart(e, { startCorner: 'top_right' })"
      class="rszbox_corner rszbox_corner_top_right"
    />
    <div
      @mousedown="(e) => handleMousedown(e, { startCorner: 'bottom_left' })"
      @touchstart="(e) => handleTouchstart(e, { startCorner: 'bottom_left' })"
      class="rszbox_corner rszbox_corner_bottom_left"
    />
    <div
      @mousedown="(e) => handleMousedown(e, { startCorner: 'bottom_right' })"
      @touchstart="(e) => handleTouchstart(e, { startCorner: 'bottom_right' })"
      class="rszbox_corner rszbox_corner_bottom_right"
    /> -->
  </div>
</template>

<script>
import { throttle } from 'lodash'

export default {
  name: 'ResizeBox',
  props: {
    dimensions: { default: () => ({ height: 0, width: 0 }) },
    // min: { default: () => ({ height: 612, width: 440 }) }, 1920
    // min: { default: () => ({ height: 440, width: 380 }) }, 1384
    min: { default: () => ({ height: 475, width: 380 }) },
    max: { default: () => ({ height: Infinity, width: 910 }) },
    // initialPlacement: { default: 'center' },
    initialStyle: { default: 'center' },
    handles: {
      default: () => ['top', 'bottom', 'right', 'left'],
    },
    cornerHandles: {
      default: () => ['top_left', 'top_right', 'bottom_left', 'bottom_right'],
    },
  },
  emits: ['update:dimensions', 'reposition:toggle', 'set:moveXY'],
  data() {
    return {
      mousedown: false,
      // startEdge: '',
      startCorner: '',

      initial: { height: 0, width: 0 },
      current: { height: 0, width: 0 },

      reversedX: false,
      reversedY: false,
      moveX: true,
      moveY: true,
    }
  },
  beforeUnmount() {
    this.removeEventListeners()
  },
  methods: {
    // initialize() {
    // if (times > 4) return
    //  if (!this.$refs?.cont) {
    // setTimeout(() => {
    //   this.initialize(times + 1)
    // }, 100)
    //  return
    //  }
    //  const {
    //  height,
    //  width,
    //  } = this.$refs.cont.getBoundingClientRect()
    //   const dd = this.dimensions
    //   this.initial = {
    //     width: dd.width || width,
    //     height: dd.height || height,
    //   }
    //   this.current = {
    //     width: dd.width || width,
    //     height: dd.height || height,
    //   }
    // },
    setMousedown(bool) {
      if (this.mousedown === bool) return
      this.mousedown = bool
    },
    handleMouseup() {
      this.setMousedown(false)
      this.removeEventListeners()
      this.$emit('update:dimensions', {
        width: this.current.width,
        height: this.current.height,
      })
    },
    removeEventListeners() {
      window.removeEventListener('mouseup', this.handleMouseup)
      window.removeEventListener('mousemove', this.handleMousemove)
      window.removeEventListener('touchend', this.handleMousemove)
      window.removeEventListener('touchmove', this.handleMouseup)
    },
    handleTouchstart(e, { startEdge, startCorner }) {
      this.handleStart(e, { startEdge, startCorner, eventType: 'touchstart' })
    },
    handleMousedown(e, { startEdge, startCorner }) {
      this.handleStart(e, { startEdge, startCorner, eventType: 'mousedown' })
    },
    handleStart(e, { startEdge, startCorner, eventType }) {
      this.setMousedown(true)

      // this.startEdge = startEdge
      this.startCorner = startCorner

      this.reversedX =
        ['bottom', 'right'].includes(startEdge) ||
        ['top_right', 'bottom_right'].includes(startCorner)
      this.reversedY =
        ['bottom', 'right'].includes(startEdge) ||
        ['bottom_left', 'bottom_right'].includes(startCorner)

      this.moveX = ['left', 'right'].includes(startEdge) || !!startCorner
      this.moveY = ['top', 'bottom'].includes(startEdge) || !!startCorner

      this.start(e)
      this.move(e)
      if (eventType === 'mousedown') {
        window.addEventListener('mouseup', this.handleMouseup)
        window.addEventListener('mousemove', this.handleMousemove, { passive: false })
      } else {
        window.addEventListener('touchend', this.handleMouseup)
        window.addEventListener('touchmove', this.handleMousemove)
      }

      if (!this.reversedX || !this.reversedY) {
        // this.$emit('reposition:toggle', true)
        this.$emit(eventType === 'mousedown' ? 'reposition:mousedown' : 'reposition:touchstart', {
          e,
          moveX: this.canMoveX,
          moveY: this.canMoveY,
          reversedX: false,
          reversedY: false,
        })
      }
    },

    start(e) {
      let { clientX, clientY } = e

      if (e?.touches) {
        clientY = e?.touches[0]?.clientY
        clientX = e?.touches[0]?.clientX
      }
      const { height, width } = this.$refs.cont.getBoundingClientRect()

      this.initial = { width, height, clientX, clientY }
      this.current = { width, height }
    },
    handleMousemove: throttle(function (e) {
      if (this.mousedown) {
        this.move(e)
      }
    }, 1),
    move(e) {
      this.setCoordinates(this.getCoordinates(e))
    },
    setCoordinates({ width, height }) {
      this.current.height = height
      this.current.width = width

      this.$emit('set:moveXY', {
        moveX: this.canMoveX,
        moveY: this.canMoveY,
      })
    },
    getCoordinates(e) {
      let { clientX, clientY } = e
      if (e?.touches) {
        clientX = e?.touches[0]?.clientX
        clientY = e?.touches[0]?.clientY
      }

      let diffX = this.initial.clientX - clientX
      let diffY = this.initial.clientY - clientY
      if (this.reversedX) {
        diffX *= -1
      }
      if (this.reversedY) {
        diffY *= -1
      }

      const maxX = window.innerWidth
      const maxY = window.innerHeight

      let width =
        clientX <= 0
          ? this.current.width
          : clientX >= maxX
            ? this.current.width
            : this.moveX
              ? this.initial.width + diffX
              : this.initial.width
      let height =
        clientY <= 0
          ? this.current.height
          : clientY >= maxY
            ? this.current.height
            : this.moveY
              ? this.initial.height + diffY
              : this.initial.height

      height =
        height <= this.min.height
          ? this.min.height
          : height >= this.max.height
            ? this.max.height
            : height
      width =
        width <= this.min.width ? this.min.width : width >= this.max.width ? this.max.width : width

      const res = {
        diffX,
        diffY,
        width,
        height,
      }
      // console.log(res)
      return res
    },
  },
  computed: {
    boxStyle() {
      return {
        '--height': this.current.height ? `${this.current.height}px` : '100%',
        '--width': this.current.width ? `${this.current.width}px` : '100%',
      }
    },
    canMoveX() {
      return this.moveX && this.canResizeX && this.startCorner !== 'top_right'
    },
    canMoveY() {
      return this.moveY && this.canResizeY && this.startCorner !== 'bottom_left'
    },
    canResizeX() {
      return this.current.width > this.min.width && this.current.width < this.max.width
    },
    canResizeY() {
      return this.current.height > this.min.height && this.current.height < this.max.height
    },
  },
}
</script>
<style lang="scss" scoped>
.rszbox {
  --edge-size: 0.75rem;
  position: relative;
  display: flex;

  --width: 100%;
  --height: 100%;
  --min-width: auto;
  --min-height: auto;
  --max-width: auto;
  --max-height: auto;
  height: var(--height);
  width: var(--width);
  min-width: var(--min-width);
  min-height: var(--min-height);
  max-width: var(--max-width);
  max-height: var(--max-height);
  // overflow: hidden;
  &_content {
    position: relative;
    display: flex;
    min-width: 0;
    min-height: 0;
    // z-index: 1;
    // z-index: 3;
    z-index: 2;
  }
  &_edge {
    min-width: var(--edge-size);
    min-height: var(--edge-size);
    position: absolute;
    z-index: 2;
    // z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    // &::before {
    //   content: '';
    //   position: absolute;
    //   height: 10rem;
    //   width: 0.25rem;
    //   border-radius: 99px;
    //   background: var(--handle-color, orange);
    //   opacity: 0;
    //   transition: 0.22s;
    //   inset: auto auto auto -0.375rem;
    // }
    // &:hover {
    //   &:before {
    //     opacity: 1;
    //   }
    // }
    // &:active {
    //   &:before {
    //     opacity: 1;
    //   }
    // }
  }
  &_top {
    cursor: ns-resize;
    width: 100%;
    inset: 0 auto auto 0;
  }
  &_bottom {
    cursor: ns-resize;
    width: 100%;
    inset: auto auto 0 0;
  }
  &_right {
    cursor: ew-resize;
    height: 100%;
    inset: 0 0 auto auto;
  }
  &_left {
    cursor: ew-resize;
    height: 100%;
    inset: 0 auto auto 0;
  }
  &_corner {
    position: absolute;
    min-width: var(--edge-size);
    min-height: var(--edge-size);
    z-index: 3;
    &_top {
      &_left {
        cursor: nwse-resize;
        inset: 0 auto auto 0;
      }
      &_right {
        cursor: nesw-resize;
        inset: 0 0 auto auto;
      }
    }
    &_bottom {
      &_left {
        cursor: nesw-resize;
        inset: auto auto 0 0;
      }
      &_right {
        cursor: nwse-resize;
        inset: auto 0 0 auto;
      }
    }
  }
}
</style>
